export const GET_PASSWORDSTATUS = 'GET_PASSWORDSTATUS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js